{
  "image-alt": "Иконка кнопки"
}
